<template>
  <div class="gpt-concept" v-loading="dataLoading">
    <el-card class="gpt-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>Prompt</span>
        <el-button class="top-botton" type="primary" size="small" icon="el-icon-check"
          @click="setSettings">Save</el-button>
        <el-button class="top-botton top-next-botton" type="" size="small" icon="el-icon-refresh"
          @click="fetchSettings">Fresh</el-button>
      </div>
      <el-form class="gpt-form" ref="form" label-width="120px" :model="form" size="mini">
        <el-form-item label="Basic">
          <el-input type="textarea" v-model="form.basic.value" autosize></el-input>
        </el-form-item>
        <el-form-item label="Negative">
          <el-input type="textarea" v-model="form.negative.value" autosize></el-input>
        </el-form-item>
        <el-form-item class="no-bottom-margin" label="Season">
          <el-button icon="el-icon-plus" size="mini" type="primary" plain circle class="add-botton"
            @click="addKey('conceptSeason')">
          </el-button>
          <el-form-item v-for="item in form.season" :key="item.key">
            <el-col :span="1">
              <el-button icon="el-icon-minus" size="mini" type="danger" plain circle style="display: block"
                @click="removeOption({ 'type': 'conceptSeason', key: item.key, subKey: item.subKey, thirdKey: item.thirdKey, fourthKey: item.fourthKey })">
              </el-button>
            </el-col>
            <el-col class="row-input" :span="23">
              <el-input v-model="item.value">
                <template slot="prepend">{{ item.key }}</template>
              </el-input>
            </el-col>
          </el-form-item>
        </el-form-item>
        <el-form-item class="no-bottom-margin" label="Prompt">
          <el-button icon="el-icon-plus" size="mini" type="primary" plain circle class="add-botton"
            @click="addKey('conceptPrompt')">
          </el-button>
          <el-form-item v-for="item in form.prompt" :key="item.key">
            <el-col :span="1">
              <el-button icon="el-icon-minus" size="mini" type="danger" plain circle style="display: block"
                @click="removeOption({ 'type': 'conceptPrompt', key: item.key, subKey: item.subKey, thirdKey: item.thirdKey, fourthKey: item.fourthKey })">
              </el-button>
            </el-col>
            <el-col class="row-input" :span="23">
              <el-input v-model="item.value">
                <template slot="prepend">{{ item.key }}</template>
              </el-input>
            </el-col>
          </el-form-item>
        </el-form-item>
        <el-form-item class="no-bottom-margin" label="Place">
          <el-button icon="el-icon-plus" size="mini" type="primary" plain circle class="add-botton"
            @click="addKey('conceptPlace')">
          </el-button>
          <el-form-item v-for="item in form.place" :key="item.key">
            <el-col :span="1">
              <el-button icon="el-icon-minus" size="mini" type="danger" plain circle style="display: block"
                @click="removeOption({ 'type': 'conceptPlace', key: item.key, subKey: item.subKey, thirdKey: item.thirdKey, fourthKey: item.fourthKey })">
              </el-button>
            </el-col>
            <el-col class="row-input" :span="23">
              <el-input v-model="item.value">
                <template slot="prepend">{{ item.key }}</template>
              </el-input>
            </el-col>
          </el-form-item>
        </el-form-item>
        <el-form-item class="no-bottom-margin" label="Sex">
          <el-button icon="el-icon-plus" size="mini" type="primary" plain circle class="add-botton"
            @click="addKey('conceptSex')">
          </el-button>
          <el-form-item v-for="item in form.sex" :key="item.key">
            <el-col :span="1">
              <el-button icon="el-icon-minus" size="mini" type="danger" plain circle style="display: block"
                @click="removeOption({ 'type': 'conceptSex', key: item.key, subKey: item.subKey, thirdKey: item.thirdKey, fourthKey: item.fourthKey })">
              </el-button>
            </el-col>
            <el-col class="row-input" :span="23">
              <el-input v-model="item.value">
                <template slot="prepend">{{ item.key }}</template>
              </el-input>
            </el-col>
          </el-form-item>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { fetchGptSettings, setGptSettings, addGptSettingsType, deleteGptSettingsType } from "@/api/admin";

export default {
  data() {
    return {
      form: {
        basic: { type: "conceptBasic", value: "" },
        negative: { type: "conceptNegative", value: "" },
        season: [],
        prompt: [],
        place: [],
        sex: [],
      },
      dataLoading: false,
    };
  },
  mounted() {
    this.active();
  },
  methods: {
    clearForm() {
      this.form = {
        basic: { type: "conceptBasic", value: "" },
        negative: { type: "conceptNegative", value: "" },
        season: [],
        prompt: [],
        place: [],
        sex: [],
      };
    },
    fetchSettings() {
      this.dataLoading = true;
      fetchGptSettings({ category: "concepter" })
        .then((response) => {
          if (response.success) {
            this.clearForm();
            response.result.forEach((t) => {
              if (t.type === "conceptBasic") {
                this.form.basic = t;
              } else if (t.type === "conceptNegative") {
                this.form.negative = t;
              } else if (t.type === "conceptSeason") {
                this.form.season.push(t);
              } else if (t.type === "conceptPrompt") {
                this.form.prompt.push(t);
              } else if (t.type === "conceptPlace") {
                this.form.place.push(t);
              } else if (t.type === "conceptSex") {
                this.form.sex.push(t);
              }
            });
          }
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    setSettings() {
      let v = [];
      v.push(this.form.basic);
      v.push(this.form.negative);
      v = v.concat(this.form.season);
      v = v.concat(this.form.prompt);
      v = v.concat(this.form.place);
      v = v.concat(this.form.sex);
      this.dataLoading = true;
      setGptSettings({ data: v })
        .then((response) => {
          if (response.success) {
            this.$notify({
              title: "Update successful",
              type: "success",
            });
            this.fetchSettings();
          }
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    active() {
      this.fetchSettings();
    },
    addKey(type) {
      this.$prompt('It takes effect immediately after confirm', 'Create Key', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
        inputValidator: (value) => {
          if (!value) {
            return "key can not be empty"
          }
        }
      }).then(({ value }) => {
        addGptSettingsType({ "type": type, "key": value }).then(response => {
          if (response.success) {
            this.$notify({
              title: "Create successful",
              type: "success",
            });
            this.fetchSettings();
          }
        })
      }).catch(() => {
      });
    },
    removeOption(data) {
      this.$confirm('It takes effect immediately after confirm', 'Delete this key?', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        deleteGptSettingsType(data).then(response => {
          if (response.success) {
            this.$notify({
              title: "Delete successful",
              type: "success",
            });
            this.fetchSettings();
          }
        })
      }).catch(() => {
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.gpt-concept {
  .gpt-card {
    margin-bottom: 10px;

    .top-botton {
      float: right;
      margin-top: -8px;
      margin-bottom: -8px
    }

    .top-next-botton {
      margin-right: 10px;
    }


    .gpt-form {
      margin-bottom: -10px;

      .add-botton {
        margin-bottom: 18px;
        display: block
      }

      .row-input {
        margin-top: 1px
      }

      .no-bottom-margin {
        margin-bottom: 0;
      }
    }
  }
}
</style>